import { useState } from "react";
import emailjs from "emailjs-com";
import "./Donatenow.css";
import { FaArrowDown } from "react-icons/fa";

function DonateNow() {
  const [screenshot, setScreenshot] = useState(null);
  const [loading, setLoading] = useState(false);

  // File compression before sending
  const handleFileChange = (e) => {
    if (e.target.files.length > 0) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onloadend = () => {
        const img = new Image();
        img.src = reader.result;
        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          // Resize (max width 600px)
          const MAX_WIDTH = 600;
          const scaleSize = MAX_WIDTH / img.width;
          canvas.width = MAX_WIDTH;
          canvas.height = img.height * scaleSize;

          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          // Compress to JPEG at 0.6 quality
          const compressed = canvas.toDataURL("image/jpeg", 0.6);
          setScreenshot(compressed);
        };
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const form = e.target;
    const formData = {
      from_name: form.name.value,
      mobile: form.mobile.value,
      payment_method: form.payment.value,
      utr_number: form.utr.value,
      screenshot: screenshot,
    };

    emailjs
      .send(
        "service_lv2cgr7", // 🔹 Replace
        "template_zho5jrs", // 🔹 Replace
        formData,
        "IBadFU7RAb1dIjvNz" // 🔹 Replace
      )
      .then(
        () => {
          alert("✅ Thank you! Your donation details have been sent.");
          setLoading(false);
          form.reset();
          setScreenshot(null);
        },
        (err) => {
          console.error("❌ EmailJS Error:", err);
          alert("Failed to send. Please try again.");
          setLoading(false);
        }
      );
  };

  return (
    <div className="donate-page">
      <div className="donate-card">
        <h1>Support Gauseva</h1>
        <p className="subtext">
          Your donation brings blessings of peace, prosperity, and happiness.
        </p>

        {/* Step 1: Payment Info */}
        <div className="payment-section">
          <h2>Step 1: Make Your Donation</h2>
          <div className="payment-methods">
            <div className="qr-box">
              <img
                src="/assets/UPI_Jyotish.jpeg"
                alt="Scan to Donate"
                className="qr"
              />
              <p>Scan with any UPI app</p>
            </div>
            <div className="upi-details">
              <p>
                <strong>UPI ID:</strong> jyotishkarmaa@okaxis
              </p>
              <p>
                <strong>Bank:</strong> AXIS Bank
              </p>
              <p>
                <strong>Account No:</strong> 923010048103133
              </p>
              <p>
                <strong>IFSC Code:</strong> UTIB0001159
              </p>
              <p>
                <strong>Swift Code:</strong> AXISIN88053
              </p>
              <p>
                <strong>Suggested Donation:</strong> ₹500 / ₹1000 / Custom
              </p>
            </div>
          </div>
        </div>

        {/* Step 2: Form */}
        <div className="form-section">
          <h2>Step 2: Submit Your Donation Details</h2>
          <form onSubmit={handleSubmit}>
            <input type="text" name="name" placeholder="Your Full Name" required />
            <input type="tel" name="mobile" placeholder="Mobile Number" required />

            <select name="payment" required>
              <option value="">Select Payment Method</option>
              <option value="upi">UPI</option>
              <option value="bank">Bank Transfer</option>
            </select>

            <input type="text" name="utr" placeholder="UTR / Reference Number" required />

            <label style={{ marginTop: "10px" }}>
              Upload Payment Screenshot:
            </label>
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              required
            />

            {screenshot && (
              <div className="preview-box">
                <p>
                  <strong>Preview:</strong>
                </p>
                <img
                  src={screenshot}
                  alt="Screenshot Preview"
                  style={{ width: "200px", marginTop: "10px" }}
                />
              </div>
            )}

            <button type="submit" disabled={loading}>
              {loading ? "Sending..." : "Submit Donation Info"}
            </button>
          </form>
        </div>

        {/* Help */}
        <div className="help">
          <p>
            Need help? <a href="tel:+918840155356">Call us</a> or{" "}
            <a
              href="https://wa.me/918840155356"
              target="_blank"
              rel="noreferrer"
            >
              Chat on WhatsApp
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default DonateNow;
